import {isEmpty} from 'ramda';

import {VehiclePhotoResponseBody} from '@dms/api/shared';

import {getAlbumVideos} from '../../../utils/getGridPhotos';
import {HistoricalServiceCaseAlbum} from '../types/HistoricalServiceCaseAlbum';
import {ServiceCasePhotoAlbum} from '../types/ServiceCasePhotoAlbum';
import {getServiceCasePhotoTiles} from './getServiceCasePhotoTiles';

/**
 * Splits the vehicle photos of one service case into its albums, keeping the album name so each
 * album renders under its own heading. Albums without renderable media are dropped - photoCount
 * counts every file, including videos and media the storage service could not process.
 */
export const getServiceCasePhotoAlbums = (
  albums: HistoricalServiceCaseAlbum[],
  photos: VehiclePhotoResponseBody[]
): ServiceCasePhotoAlbum[] =>
  albums.flatMap((album) => {
    const albumPhotos = photos.filter((photo) => photo.albumId === album.id);
    const tiles = getServiceCasePhotoTiles(albumPhotos);
    const videos = getAlbumVideos(albumPhotos);

    if (isEmpty(tiles) && isEmpty(videos)) {
      return [];
    }

    return [
      {
        id: album.id,
        title: album.translation,
        createdAt: album.createdAt,
        photos: tiles,
        videos,
      },
    ];
  });
